"use strict";

exports.__esModule = true;
exports.default = void 0;

var _jumbotron = _interopRequireDefault(require("./jumbotron"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BJumbotron: _jumbotron.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/jumbotron/index.js
// module id = 387
// module chunks = 0